import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import ReactConfetti from 'react-confetti'; // Removed Confetti import
import './SubmitSuccess.css';

export default function SubmitSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get state from location or use defaults
  const isEdit = location.state?.isEdit || false;
  const customMessage = location.state?.message || (isEdit 
    ? 'Your profile has been updated successfully!' 
    : 'Your profile has been submitted successfully!');

  // Get profile data from location state
  const profileData = location.state?.profileData || {};
  
  // Use a default rating if none is provided
  const displayRating = profileData.rating || 1200;

  const [showConfetti, setShowConfetti] = useState(true);
  const [confettiPieces, setConfettiPieces] = useState([]);
  const [iconLoadError, setIconLoadError] = useState(false);

  // If there's no state, the user might have navigated here directly
  useEffect(() => {
    if (!location.state) {
      // Redirect to account page after a short delay
      const timer = setTimeout(() => {
        navigate('/account');
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [location.state, navigate]);

  // Generate confetti for initial submission only
  useEffect(() => {
    if (!isEdit) {
      const pieces = [];
      const colors = ['#ffcf40', '#00bfa5', '#f06292', '#0066ff', '#be9cfe'];
      
      for (let i = 0; i < 150; i++) {
        pieces.push({
          id: i,
          x: Math.random() * 100,
          y: -20 - Math.random() * 100,
          size: 5 + Math.random() * 15,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * 360,
          animationDelay: Math.random() * 2
        });
      }
      
      setConfettiPieces(pieces);
      
      // Hide confetti after 5 seconds
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [isEdit]);
  
  // Helper function for random colors
  function getRandomColor() {
    const colors = [
      '#FFC107', // Yellow
      '#FF5722', // Orange
      '#E91E63', // Pink
      '#9C27B0', // Purple
      '#3F51B5', // Indigo
      '#2196F3', // Blue
      '#4CAF50', // Green
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  return (
    <div className="success-container">
      {showConfetti && !isEdit && (
        <div className="confetti-container">
          {confettiPieces.map(piece => (
            <div
              key={piece.id}
              className="confetti-piece"
              style={{
                left: `${piece.x}vw`,
                top: `${piece.y}vh`,
                width: `${piece.size}px`,
                height: `${piece.size * 0.6}px`,
                backgroundColor: piece.color,
                transform: `rotate(${piece.rotation}deg)`,
                animationDelay: `${piece.animationDelay}s`
              }}
            />
          ))}
        </div>
      )}
      
      <div className={`success-card ${isEdit ? 'edit-mode' : ''}`}>
        <div className="success-icon">
          {isEdit ? (
            <div className="edit-icon">✓</div>
          ) : (
            iconLoadError ? (
              <span className="fallback-emoji">🎉</span>
            ) : (
              <img
                src="/party-popper.svg"
                alt="Success"
                onError={() => setIconLoadError(true)}
              />
            )
          )}
        </div>
        
        <h1 className="success-title">
          {isEdit ? 'Profile Updated!' : 'Profile Submitted!'}
        </h1>
        
        <p className="success-message">{customMessage}</p>
        
        <div className="action-buttons">
          <Link to="/account" className="action-button view-profile">
            View My Profile
          </Link>
          
          <Link to="/leaderboard" className="action-button view-leaderboard">
            View Leaderboard
          </Link>

          <Link to="/compare" className="action-button compare-profiles">
            Compare Profiles
          </Link>
        </div>
      </div>
    </div>
  );
} 